import { render, staticRenderFns } from "./Promotionsregelliste.vue?vue&type=template&id=3d5f9e62&"
import script from "./Promotionsregelliste.vue?vue&type=script&lang=js&"
export * from "./Promotionsregelliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports